// src/api.js
// Comunicação do app com a API do servidor (que guarda os dados no Firebird).
// O login continua no Firebase Authentication; cada chamada envia o token do usuário logado.
import { auth } from './firebaseConfig';

// Em produção o site e a API ficam no mesmo endereço. No "npm start" (localhost:3000)
// a API roda em localhost:3001 (ou no endereço definido em REACT_APP_API_URL).
export const API_BASE = (process.env.REACT_APP_API_URL
    || (typeof window !== 'undefined' && window.location.port === '3000' ? 'http://localhost:3001' : '')).replace(/\/$/, '');

export const obterToken = async () => {
    const u = auth.currentUser;
    if (!u) throw new Error('Faça login para continuar.');
    return u.getIdToken();
};

// Campos "timestamp..." chegam como texto (ISO). Para as telas continuarem funcionando como no
// Firebase, viram objetos com toDate() / toMillis().
const comoTimestamp = (iso) => {
    const d = new Date(iso);
    return { toDate: () => new Date(d), toMillis: () => d.getTime(), seconds: Math.floor(d.getTime() / 1000) };
};
export const adaptar = (obj) => {
    if (Array.isArray(obj)) return obj.map(adaptar);
    if (!obj || typeof obj !== 'object') return obj;
    const r = { ...obj };
    Object.keys(r).forEach((k) => {
        if (k.startsWith('timestamp') && typeof r[k] === 'string' && r[k]) r[k] = comoTimestamp(r[k]);
    });
    return r;
};

// consultor inativado: o App escuta este aviso, encerra a sessão e mostra a mensagem no login
export const EVENTO_BLOQUEIO = 'chamados:acesso-bloqueado';
export const avisarBloqueio = (mensagem) => {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(EVENTO_BLOQUEIO, { detail: mensagem || 'Seu acesso ao sistema foi bloqueado.' }));
};

const chamar = async (metodo, caminho, corpo) => {
    const token = await obterToken();
    let resp;
    try {
        resp = await fetch(`${API_BASE}/api${caminho}`, {
            method: metodo,
            headers: { Authorization: `Bearer ${token}`, ...(corpo !== undefined ? { 'Content-Type': 'application/json' } : {}) },
            body: corpo !== undefined ? JSON.stringify(corpo) : undefined,
        });
    } catch (e) {
        throw new Error('Não foi possível falar com o servidor. Verifique a conexão.');
    }
    const dados = await resp.json().catch(() => ({}));
    if (resp.status === 403 && dados.codigo === 'bloqueado') avisarBloqueio(dados.erro);
    if (!resp.ok) {
        const erro = new Error(dados.erro || `Erro ${resp.status} no servidor.`);
        erro.status = resp.status;
        throw erro;
    }
    return adaptar(dados);
};

export const api = {
    get: (c) => chamar('GET', c),
    post: (c, corpo = {}) => chamar('POST', c, corpo),
    put: (c, corpo = {}) => chamar('PUT', c, corpo),
    del: (c) => chamar('DELETE', c),
};
